import { EnvironmentNames } from "@origin-digital/platform-enums";
import { INavigationData, ITaskData } from "@origin-digital/reporting-client";

import {
  EVENT_NAV_PREFIX,
  NAVIGATION_DOMAIN,
  PAC_DOMAIN_URI,
  PRODUCTION_DOMAIN_URI,
} from "./config";

export const shouldUseEventDispatch = (buttonLink: string) =>
  buttonLink && buttonLink.indexOf(EVENT_NAV_PREFIX) === 0;

// Converts event values to kebab-case
// needs to allow appNames with `:` and `-` (e.g. `rx-my-account:reward`)
export const setKebabCase = (str: string) => {
  if (!str) return "";
  return str
    .trim()
    .replace(/[^a-zA-Z0-9\s\-:]/g, "") // Remove non-alphanumeric characters except `\s`, `:` and `-`
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/([a-z])([A-Z])/g, "$1-$2") // Convert camelCase to kebab-case
    .toLowerCase();
};

// Format to return currentUri (replace domain, remove parameters, and remove trailing slash)
export const formatUri = (
  environment: EnvironmentNames,
  currentUri: string
) => {
  // remove parameters first
  const removeParametersUri = currentUri.split("?")[0];

  // slice off either *origindigital-pac.com.au or *originenergy.com.au
  // and replace with NAVIGATION_DOMAIN
  const domain =
    environment === "prod" ? PRODUCTION_DOMAIN_URI : PAC_DOMAIN_URI;

  // if currentUri start with a `/` prefix with NAVIGATION_DOMAIN otherwise replace domain
  const domainCorrectedUri = removeParametersUri.startsWith("/")
    ? NAVIGATION_DOMAIN + removeParametersUri
    : removeParametersUri.replace(
        new RegExp(`(.*)${domain}`, "g"),
        NAVIGATION_DOMAIN
      );

  // remove trailing `/`
  return domainCorrectedUri?.replace(/\/*$/, "");
};

export const isITaskDataType = (
  data: ITaskData | INavigationData
): data is ITaskData => {
  return "action" in data;
};

// Remove PII from ITaskData event data
export const clearPIIFromData = (data: ITaskData | INavigationData) => {
  if (!isITaskDataType(data)) {
    return data;
  }
  const cleanedData = { ...data };
  // Remove PII fields
  delete cleanedData.state;
  delete cleanedData.postcode;
  if (cleanedData.user) {
    cleanedData.user = { ...cleanedData.user };
    delete cleanedData.user.email;
  }
  return cleanedData as ITaskData;
};
